import React, { useEffect, useState } from "react";
import Heading from "../../components/Heading";
import CommonGrid from "../../components/CommonGrid";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer";
import { gridColumns_payoff_authorization, gridColumns_payoff_authorization_borrower } from "../../Utils/TableColumnDefs";
import { useDispatch, useSelector } from "react-redux";
import { fetchPayoffDemandsThirdParty } from "../../store/reducers/dashboardSlice/api";
import { useAbortController } from "../../hooks/useAbortController";
import classes from "../../pages/ReportsNDocuments/reports.module.css";
import { LiHandleButton } from "../../Utils/CustomComponent";

const PayoffAuthRequests = () => {
  const [activeTab, setActiveTab] = useState(0);
  const thirdPartyRequests = useSelector(
    (state) => state.dashboard.thirdPartyPayoffRequests.data,
  );
  const thirdPartyStatus = useSelector(
    (state) => state.dashboard.thirdPartyPayoffRequests.status,
  );
  const user = useSelector((state) => state.RS_Authentication.user);
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.value,
  );

  const PendingRequests =
    thirdPartyRequests?.filter((el) => el.status === "PENDING") || [];
  const RejectedRequests =
    thirdPartyRequests?.filter((el) => el.status === "EXPIRED") || [];
  const SubmittedRequests =
    thirdPartyRequests?.filter((el) => el.status === "SUBMITTED") || [];

  const dispatch = useDispatch();
  const { signal } = useAbortController();

  useEffect(() => {
    dispatch(
      fetchPayoffDemandsThirdParty({
        email: user?.details?.email,
        signal,
      }),
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const componentConfig = [
    {
      component: <Heading className="col-sm-12" text="Pending Authorization" />,
      role: ["Both"],
      className: "col-sm-6 px-5",
    },
    // {
    //   component: (
    //     <Button
    //       className="text-white create-ticket"
    //       onClick={() => navigate("/payoff-request-form")}
    //     >
    //       <FaHandshake className="me-3" /> Request Payoff
    //     </Button>
    //   ),
    //   // role: ["Both"],
    //   className: "col-sm-6 px-5 text-end",
    // },

    {
      component: (
        <div>
          <ul className="nav nav-tabs my-5">
            {tabButtons.map((data, index) => (
              <LiHandleButton
                key={index}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                label={data.label}
                value={index}
                handleBtnClick={setActiveTab}
              />
            ))}
          </ul>

          <section className="row d-flex flex-row align-items-stretch justify-content-stretch">
            {activeTab === 0 && (
              <CommonGrid
                className={classes.pastDue25}
                title={"Borrower Authorization Required"}
                gridColumns={gridColumns_payoff_authorization_borrower(false)}
                columnData={PendingRequests}
                status={thirdPartyStatus}
              />
            )}
            {activeTab === 1 && (
              <CommonGrid
                className={classes.pastDue25}
                title={"Submitted Payoff Request(s)"}
                gridColumns={gridColumns_payoff_authorization_borrower(false)}
                columnData={SubmittedRequests}
                status={thirdPartyStatus}
              />
            )}
            {activeTab === 2 && (
              <CommonGrid
                className={classes.pastDue25}
                title={"Rejected Payoff Request(s)"}
                gridColumns={gridColumns_payoff_authorization_borrower(false)}
                columnData={RejectedRequests}
                status={thirdPartyStatus}
              />
            )}
          </section>
        </div>
      ),
      role: ["Both"],
      className: "col-sm-12 px-4",
    },
  ];
  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded py-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid row mt-5">
          <DynamicComponentRenderer componentConfig={componentConfig} />
        </article>
      </section>
    </div>
  );
};

export default PayoffAuthRequests;

const tabButtons = [
  {
    label: "Borrower Authorization Required",
    title: "Borrower Authorization Required",
  },
  {
    label: "Submitted Payoff Request(s)",
    title: "Submitted Payoff Request(s)",
  },
  { label: "Rejected Payoff Request(s)", title: "Rejected Payoff Request(s)" },
];
